var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_5310_55552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0049 13.75C15.0049 14.7446 14.6098 15.6984 13.9065 16.4017C13.2033 17.1049 12.2494 17.5 11.2549 17.5C10.2603 17.5 9.30649 17.1049 8.60323 16.4017C7.89997 15.6984 7.50488 14.7446 7.50488 13.75C7.50488 12.7554 7.89997 11.8016 8.60323 11.0983C9.30649 10.3951 10.2603 10 11.2549 10C12.2494 10 13.2033 10.3951 13.9065 11.0983C14.6098 11.8016 15.0049 12.7554 15.0049 13.75Z",
    fill: "#2C333A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5C2.75544 5 1.80161 5.39509 1.09835 6.09835C0.395088 6.80161 0 7.75544 0 8.75L0 31.25C0 32.2446 0.395088 33.1984 1.09835 33.9017C1.80161 34.6049 2.75544 35 3.75 35H36.25C37.2446 35 38.1984 34.6049 38.9016 33.9017C39.6049 33.1984 40 32.2446 40 31.25V8.75C40 7.75544 39.6049 6.80161 38.9016 6.09835C38.1984 5.39509 37.2446 5 36.25 5H3.75ZM36.25 7.5C36.5815 7.5 36.8995 7.6317 37.1339 7.86612C37.3683 8.10054 37.5 8.41848 37.5 8.75V23.75L28.0625 18.8825C27.8281 18.7651 27.5626 18.7243 27.3037 18.766C27.0449 18.8078 26.8057 18.9298 26.62 19.115L17.345 28.39L10.695 23.96C10.4549 23.8001 10.1669 23.7283 9.87985 23.7565C9.59279 23.7848 9.32433 23.9114 9.12 24.115L2.505 30V31.35C2.50201 31.3167 2.50034 31.2834 2.5 31.25V8.75C2.5 8.41848 2.6317 8.10054 2.86612 7.86612C3.10054 7.6317 3.41848 7.5 3.75 7.5H36.25Z",
    fill: "#2C333A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5310_55552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFrame);
export default __webpack_public_path__ + "static/media/img_frame.ac3506955b7d4b40efcaa4d787ff3f1f.svg";
export { ForwardRef as ReactComponent };